import { Phone, Calendar } from "lucide-react";

export default function MobileCTA() {
  const scrollTo = (id) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div
      data-testid="mobile-cta-bar"
      className="fixed bottom-0 left-0 right-0 z-50 md:hidden bg-navy-base/95 backdrop-blur-xl border-t border-gold/20"
    >
      <div className="flex">
        <a
          href="tel:+919914601473"
          data-testid="mobile-call-btn"
          className="flex-1 flex items-center justify-center gap-2 py-4 text-gold text-sm font-semibold border-r border-gold/20"
        >
          <Phone className="w-4 h-4" />
          Call Now
        </a>
        <button
          onClick={() => scrollTo("#contact")}
          data-testid="mobile-book-btn"
          className="flex-1 flex items-center justify-center gap-2 py-4 bg-gold text-navy-dark text-sm font-semibold"
        >
          <Calendar className="w-4 h-4" />
          Book Consultation
        </button>
      </div>
    </div>
  );
}
